module.exports = __webpack_public_path__ + "static/media/king_of_hearts.09112d05.svg";